// Función para inicializar Swipers en productos recomendados y vistos recientemente
function initializeRecommendationsSwipers() {
  // Esperar un poco más para garantizar que el contenido fue cargado
  setTimeout(() => {
    const recommendationsSwipers = document.querySelectorAll('product-recommendations .product-card__swiper:not(.swiper-initialized)');
    const recentlyViewedSwipers = document.querySelectorAll('recently-viewed-products .product-card__swiper:not(.swiper-initialized)');
    
    const allSwipers = [...recommendationsSwipers, ...recentlyViewedSwipers];
    
    if (allSwipers.length > 0) {
      console.log('Inicializando Swipers para productos recomendados/vistos:', allSwipers.length);
    }
    
    allSwipers.forEach((swiperElement) => {
      // Marcar como inicializado para evitar duplicación
      swiperElement.classList.add('swiper-initialized');
      
      const swiper = new Swiper(swiperElement, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        allowTouchMove: true,
        grabCursor: true,
        navigation: {
          nextEl: swiperElement.querySelector('.swiper-button-next'),
          prevEl: swiperElement.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: swiperElement.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
        },
        // Configuraciones específicas para desktop
        breakpoints: {
          768: {
            allowTouchMove: true,
            grabCursor: true,
          }
        }
      });
    });
  }, 500); // Esperar 500ms para garantizar carga completa
}

// Función para configurar observadores de productos recomendados y vistos recientemente
function setupRecommendationsObservers() {
  // Observar específicamente cambios en product-recommendations y recently-viewed-products
  const recommendationsObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        let hasNewProducts = false;
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            // Verificar si es un product-recommendations, recently-viewed-products o contiene uno
            if (node.tagName === 'PRODUCT-RECOMMENDATIONS' || 
                node.tagName === 'RECENTLY-VIEWED-PRODUCTS' || 
                node.querySelector?.('product-recommendations') ||
                node.querySelector?.('recently-viewed-products')) {
              hasNewProducts = true;
            }
            // Verificar si contiene swipers de productos
            if (node.querySelector?.('.product-card__swiper')) {
              hasNewProducts = true;
            }
          }
        });
        if (hasNewProducts) {
          console.log('Detectados nuevos productos recomendados/vistos, inicializando Swipers...');
          initializeRecommendationsSwipers();
        }
      }
    });
  });

  // Observar cambios en product-recommendations existentes
  const recommendationsElements = document.querySelectorAll('product-recommendations');
  recommendationsElements.forEach((element) => {
    recommendationsObserver.observe(element, {
      childList: true,
      subtree: true
    });
  });

  // Observar cambios en recently-viewed-products existentes
  const recentlyViewedElements = document.querySelectorAll('recently-viewed-products');
  recentlyViewedElements.forEach((element) => {
    recommendationsObserver.observe(element, {
      childList: true,
      subtree: true
    });
  });

  // También observar el body para nuevos elementos
  recommendationsObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Retornar el observer para posible uso futuro
  return recommendationsObserver;
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setupRecommendationsObservers();
    // Intentar inicializar swipers existentes
    initializeRecommendationsSwipers();
  });
} else {
  // DOM ya está listo
  setupRecommendationsObservers();
  // Intentar inicializar swipers existentes
  initializeRecommendationsSwipers();
}

// Exponer funciones globalmente para uso manual si es necesario
window.initializeRecommendationsSwipers = initializeRecommendationsSwipers;
window.setupRecommendationsObservers = setupRecommendationsObservers;

// Escuchar evento personalizado para inicializar swipers
document.addEventListener('recommendations-loaded', () => {
  console.log('Evento recommendations-loaded disparado, inicializando Swipers...');
  initializeRecommendationsSwipers();
});

// Función para disparar evento manualmente
window.triggerRecommendationsLoaded = () => {
  document.dispatchEvent(new CustomEvent('recommendations-loaded'));
};
